export const navigation = {
  'Go back': 'Voltar',
  'Go forward': 'Avançar',
};
